<script setup>

import {useFormField} from "../../../Registration/composables/useFormField";
import FieldErrorMessage from "../../../Registration/components/Fields/FieldErrorMessage.vue";

const emit = defineEmits(['blur', 'input']);

const {item, group, groupId, backend} = defineProps(['item','group','groupId', 'backend']);
const {model, uniqueItemId, path, hasError, inputAttributes, isReadOnly, getFieldClasses, createBlurHandler, createInputHandler} = useFormField(item, group, groupId, (v) => v, (v) => v, backend);

const handleBlur = createBlurHandler(emit);
const handleInput = createInputHandler(emit);

let className = getFieldClasses('form-item-input  text-field');
</script>

<template>
    <div :class="className">
        <label :for="uniqueItemId">
            {{ item.label }}
            <span v-if="item.required && !isReadOnly"> *</span>
        </label>
        <input :id="uniqueItemId"
               type="text"
               v-model="model"
               class="form-item form-element"
               v-bind="inputAttributes"
               @blur="handleBlur"
               @input="handleInput"/>
        <FieldErrorMessage :path="path" :backend="backend" />
    </div>
</template>

<style scoped>

.is-readonly input {
    opacity: 0.5;
    pointer-events: none;
    background-color: #f8f9fa;
    cursor: not-allowed;
}

</style>
